<app-banner></app-banner>
<app-feature></app-feature>
<app-faq></app-faq>